//第三方以旧换新管理相关 api
import request from "@/utils/request";
const baseService = "autoapp-default-server-recovery";

// ============ 门店管理 start ============
/**
 * @function 门店管理-分页列表
 * @property {object}  data - 请求参数.
 * @property {number}  data.page - 页码
 * @property {number}  data.rows - 每页条数
 * @property {string}  data.id - 门店id
 * @property {string}  data.storeName - 门店名称
 * @property {string}  data.provinceCode - 省份id
 * @property {string}  data.cityCode - 城市id
 * @property {string}  data.contactMobile - 联系手机号
 */
export function getStoreList(data) {
  return request({
    url: `${baseService}/api/third-party/store/pageCondition`,
    method: "post",
    data
  });
}

/**
 * @function 门店管理-新增门店
 * @property {object}  data - 门店信息
 * @property {string}  data.storeName - 门店名（必填，最大50）
 * @property {string}  data.provinceName - 省名（必填）
 * @property {string}  data.provinceCode - 省ID（必填）
 * @property {string}  data.cityName - 城市名（必填）
 * @property {string}  data.cityCode - 城市ID（必填）
 * @property {string}  data.contactName - 联系人（必填，最大5）
 * @property {string}  data.contactMobile - 联系电话（正则 ^1[3456789]\d{9}$）
 */
export function saveStore(data) {
  return request({
    url: `${baseService}/api/third-party/store/add`,
    method: "post",
    data
  });
}

/**
 * @function 门店管理-编辑门店
 * @property {object}  data - 门店信息
 * @property {string}  data.id - 门店ID（必填）
 * @property {string}  data.storeName - 门店名（必填，最大50）
 * @property {string}  data.provinceName - 省名（必填）
 * @property {string}  data.provinceId - 省ID（必填）
 * @property {string}  data.cityName - 城市名（必填）
 * @property {string}  data.cityCode - 城市ID（必填）
 * @property {string}  data.contactName - 联系人（必填，最大5）
 * @property {string}  data.contactMobile - 联系电话（正则 ^1[3456789]\d{9}$）
 */
export function updateStore(data) {
  return request({
    url: `${baseService}/api/third-party/store/update`,
    method: "post",
    data
  });
}

/**
 * @function 门店管理-门店详情
 * @property {string}  id - 门店id
 */
export function getStoreDetail(id) {
  return request({
    url: `${baseService}/api/thirdPartyTradeIn/store/detail/${id}`,
    method: "post"
  });
}

/**
 * @function 门店管理-删除门店
 * @property {string}  id - 门店id
 */
export function deleteStore(id) {
  return request({
    url: `${baseService}/api/third-party/store/delete/${id}`,
    method: "delete"
  });
}

/**
 * @function 门店管理-禁用/启用门店
 * @property {string}  id - 门店id（路径参数）
 */
export function updateStoreStatus(id) {
  return request({
    url: `${baseService}/api/third-party/store/updateStatus/${id}`,
    method: "put"
  });
}

/**
 * @function 门店管理-导入模板下载
 */
export function downloadStoreTemplate() {
  return request({
    url: `${baseService}/api/thirdPartyTradeIn/store/downloadTemplate`,
    method: "post"
  });
}

/**
 * @function 门店管理-批量导入门店（multipart/form-data）
 * @property {file}  file - Excel 文件
 */
export function importStore(formData) {
  return request({
    url: `${baseService}/api/third-party/store/importStore`,
    method: "post",
    data: formData
  });
}

/**
 * @function 门店管理-导出分页查询第三方店铺
 * @property {object}  data - 查询参数（同分页查询）
 * @property {number}  data.page - 页码
 * @property {number}  data.rows - 每页条数
 */
export function exportStore(data) {
  return request({
    url: `${baseService}/api/third-party/store/exportPageCondition`,
    method: "post",
    data
  });
}

// ============ 旧机明细 start ============
/**
 * @function 旧机明细-分页列表
 * @property {object}  data - 请求参数
 * @property {number}  data.page - 页码
 * @property {number}  data.rows - 每页条数
 * @property {string}  data.storeId - 门店ID
 * @property {string}  data.storeName - 门店名称
 * @property {string}  data.provinceCode - 省份编码
 * @property {string}  data.cityCode - 城市编码
 * @property {string}  data.contactMobile - 用户电话
 * @property {Array<number>} data.categoryList - 旧机器分类ID列表
 * @property {string}  data.barcode - 旧机器条码
 * @property {number}  data.status - 状态 1-已登记 2-已检查
 * @property {string}  data.startRegisterDate - 开始登记时间
 * @property {string}  data.endRegisterDate - 结束登记时间
 * @property {string}  data.startCheckDate - 开始检查时间
 * @property {string}  data.endCheckDate - 结束检查时间
 * @property {number}  data.sample - 是否抽检 0-否 1-是
 * @property {number}  data.consistent - 是否一致 0-否 1-是
 */
export function getOldDeviceList(data) {
  return request({
    url: `${baseService}/api/third-party/oldMachine/pageCondition`,
    method: "post",
    data
  });
}

/**
 * @function 旧机明细-导出
 * @property {object}  data - 查询参数（同分页查询）
 * @property {number}  data.page - 页码
 * @property {number}  data.rows - 每页条数
 */
export function exportOldDevice(data) {
  return request({
    url: `${baseService}/api/third-party/oldMachine/excelPageCondition`,
    method: "post",
    data
  });
}

/**
 * @function 旧机明细-旧机详情
 * @property {string}  id - 旧机id（路径参数）
 */
export function getOldDeviceDetail(id) {
  return request({
    url: `${baseService}/api/third-party/oldMachine/getDetailById/${id}`,
    method: "get"
  });
}

/**
 * @function 旧机明细-入库（单条/批量）
 * @property {Array<string>}  data - 旧机条码数组（选择的旧机条码）
 */
export function inboundOldDevice(data) {
  return request({
    url: `${baseService}/api/third-party/oldMachine/warehousing`,
    method: "post",
    data
  });
}

/**
 * @function 旧机明细-批量入库模板下载
 */
export function downloadInboundTemplate() {
  return request({
    url: `${baseService}/api/thirdPartyTradeIn/oldDevice/downloadInboundTemplate`,
    method: "post"
  });
}

/**
 * @function 旧机明细-批量入库（旧机器返厂导入，multipart/form-data）
 * @property {file}  file - Excel 文件
 */
export function importInbound(formData) {
  return request({
    url: `${baseService}/api/third-party/oldMachine/importReturnFactory`,
    method: "post",
    data: formData
  });
}

// ============ 通用 start ============
/**
 * @function 获取以旧换新品类集合
 * @returns data: Array<{ code, desc }> - code 为品类ID，desc 为品类名称
 */
export function getCategory() {
  return request({
    url: `${baseService}/api/third-party/oldMachine/getCategory`,
    method: "get"
  });
}

/**
 * @function 获取省份
 */
export function findAllProvince(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/findAllProvince`,
    method: "post",
    data
  });
}

/**
 * @function 获取城市
 * @property {string}  provinceCode - 省份编码
 */
export function findAllCity(provinceCode) {
  return request({
    url: `${baseService}/api/partnerManagementBond/findAllCity/${provinceCode}`,
    method: "post"
  });
}



// WEBPACK FOOTER //
// ./src/api/thirdPartyTradeIn.js